import * as React from "react";
import type { SVGProps } from "react";
const SvgMountains = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 20H3c-.34 0-.65-.17-.84-.45a.976.976 0 0 1-.08-.95L6.7 7.98c.39-.91 1.16-1.47 2.05-1.52.53-.02 1.04.15 1.46.48l1.22-2.53C11.85 3.54 12.65 3 13.52 3h.03c.89.01 1.7.59 2.1 1.5l6.26 14.1c.14.31.11.67-.08.95-.18.28-.5.46-.84.46L21 20ZM4.53 18h14.94L13.83 5.31c-.1-.23-.23-.31-.3-.31-.06 0-.21.11-.3.28l-1.96 4.06c-.16.34-.5.56-.88.56-.34.02-.72-.19-.9-.52l-.37-.68c-.08-.15-.18-.24-.28-.24-.08 0-.21.09-.3.31L4.53 18Z"
    />
  </svg>
);
export default SvgMountains;
